module.exports = __webpack_public_path__ + "img/brief_picture_04.ef04faef.png";